import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import SubscriptionSuccessPage from '@/features/subscription/subscription-success-page';

const successSearchSchema = z.object({
  jobId: z.string().optional(),
});

export const Route = createFileRoute('/subscription/success')({
  validateSearch: successSearchSchema,
  loader: async ({ context }) => {
    void context;
  },
  component: SubscriptionSuccessPage,
});
